import React, { useEffect, useState } from 'react';
import {
  PlusIcon,
  PencilIcon,
  TrashIcon,
  MagnifyingGlassIcon,
  EyeIcon
} from '@heroicons/react/24/outline';
import { countries, universities, students } from '../data/mockData';
import Pagination from '../components/Pagination';
import ExportButton from '../components/ExportButton';
import { useGetCountriesQuery, useGetUniversitiesQuery,useAddCountryMutation, useUpdateCountryMutation,useDeleteCountryMutation } from '../store/api';
import CountryEditModal from '../components/modals/CountryEditModal';
import CountryViewModal from '../components/modals/CountryViewModal';
import { toast } from 'react-toastify';
import {Audio} from 'react-loader-spinner'
import TableHeader from '../components/TableHeader';

export default function Countries() {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [editingCountry, setEditingCountry] = useState(null);
  const [viewingCountry, setViewingCountry] = useState(null);
  const [activeTab, setActiveTab] = useState('universities');
  const [formData, setFormData] = useState({ name: '', code: '', is_active: 1 });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage,setItemsPerPage] = useState(10);
  const [totalPages,setTotalPages] = useState(1);
  const [totalCountryCount, setTotalCountryCount] = useState(0)
  const [countriesData, setCountriesData] = useState(null)
  const [isExport,setIsExport] = useState(0)
  const [exportData,setExportData] = useState([])

  // all category

  const { data, isError, error, isSuccess, isLoading } = useGetCountriesQuery({
      keyword: searchTerm,
      is_active: statusFilter,
      is_export: isExport,
      page: currentPage,
      limit: itemsPerPage
  })

  useEffect(() => {

    if(isExport == 1){
      const transformedData = data.data.map(country => ({
          'Ölkə Adı': country.name,
          'Kod': country.code,
          'Status': country.is_active ? 'Aktiv' : 'Deaktiv',
          'Yaradılma Tarixi': new Date(country.created_at).toLocaleString("az-AZ"),
          'ID': country.id
        }));

        setExportData(transformedData)
    }else{
      if (!isLoading && data) {
        setCountriesData(data.data.data)
        setTotalPages(Math.ceil(data.data.total / data.data.per_page))
        setTotalCountryCount(data.data.total)
      }

    }

  
  }, [data, isSuccess, isError, isLoading, error])


  const [addCountry, {
        data: createResponse,
        isError: createIsError,
        error: createError,
        isSuccess: createIsSuccess,
        isLoading: createIsLoading }] = useAddCountryMutation()


  useEffect(() => {
    if(!createIsLoading && createResponse){
       toast.success(createResponse.message);
       setIsModalOpen(false);
       setFormData({ name: '', code: '', is_active: 0 });
    }

    if(createIsError){
      // Handle error response properly
      let errorMessage = "Xəta baş verdi";
      if(createError && createError.data && createError.data.errors) {
        // Extract specific error messages from backend response
        const errors = createError.data.errors;
        const errorMessages = [];
        
        Object.keys(errors).forEach(key => {
          if(Array.isArray(errors[key])) {
            errorMessages.push(...errors[key]);
          } else {
            errorMessages.push(errors[key]);
          }
        });
        
        errorMessage = errorMessages.join(', ');
      } else if(createError && createError.data && createError.data.message) {
        errorMessage = createError.data.message;
      } else if(createError && createError.message) {
        errorMessage = createError.message;
      }
      
      toast.error(errorMessage);
    }
  },[createResponse,createIsSuccess,createIsError, createIsLoading,createError])


  // update category

  const [updateCountry, {
    data: updateData,
    isError: updateIsError,
    error: updateError,
    isSuccess: updateIsSuccess,
    isLoading: updateIsLoading }] = useUpdateCountryMutation()


  useEffect(() => {

    if (!updateIsLoading && updateData) {
      toast.success(updateData.message)
      setIsModalOpen(false);
      setEditingCountry(null);
      setFormData({ name: '', code: '', is_active: 1 });
    }

    if (updateIsError) {
      // Handle error response properly
      let errorMessage = "Yeniləmə uğursuz oldu";
      if(updateError && updateError.data && updateError.data.errors) {
        // Extract specific error messages from backend response
        const errors = updateError.data.errors;
        const errorMessages = [];
        
        Object.keys(errors).forEach(key => {
          if(Array.isArray(errors[key])) {
            errorMessages.push(...errors[key]);
          } else {
            errorMessages.push(errors[key]);
          }
        });
        
        errorMessage = errorMessages.join(', ');
      } else if(updateError && updateError.data && updateError.data.message) {
        errorMessage = updateError.data.message;
      } else if(updateError && updateError.message) {
        errorMessage = updateError.message;
      }
      
      toast.error(errorMessage);
      console.log(updateError);
    }
  }, [updateData, updateIsSuccess, updateIsError, updateIsLoading, updateError])

  const [deleteCountry,{
        data: deleteRes,
        isError: deleteIsError,
        error: deleteError,
        isSuccess: deleteIsSuccess,
        isLoading: deleteIsLoading
      }] = useDeleteCountryMutation() 
  
    
      useEffect(() => {
        if(!deleteIsLoading && deleteRes){
          toast.success(deleteRes.message);
        }
        
        if(deleteIsError) {
          // Handle error response properly
          let errorMessage = "Silmə uğursuz oldu";
          if(deleteError && deleteError.data && deleteError.data.errors) {
            // Extract specific error messages from backend response
            const errors = deleteError.data.errors;
            const errorMessages = [];
            
            Object.keys(errors).forEach(key => {
              if(Array.isArray(errors[key])) {
                errorMessages.push(...errors[key]);
              } else {
                errorMessages.push(errors[key]);
              }
            });
            
            errorMessage = errorMessages.join(', ');
          } else if(deleteError && deleteError.data && deleteError.data.message) {
            errorMessage = deleteError.data.message;
          } else if(deleteError && deleteError.message) {
            errorMessage = deleteError.message;
          }
          
          toast.error(errorMessage);
        }
      }, [deleteRes, deleteIsError, deleteError, deleteIsLoading])



  // Pagination calculations
  const startIndex = (currentPage - 1) * itemsPerPage;



  const exportHeaders = ['Ölkə Adı', 'Kod', 'Status', 'Yaradılma Tarixi', 'ID'];

  const handleAdd = () => {
    setEditingCountry(null);
    setFormData({ name: '', code: '', is_active: 1 });
    setIsModalOpen(true);
  };

  const handleEdit = (country) => {
    setEditingCountry(country);
    setFormData({ name: country.name, code: country.code, is_active: country.is_active });
    setIsModalOpen(true);
  };

  const handleView = (country) => {
    setViewingCountry(country);
    setActiveTab('universities');
    setIsViewModalOpen(true);
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setStatusFilter('');
    setCurrentPage(1);
  };

  const handleDelete = (countryId) => {
    if (window.confirm('Bu ölkəni silmək istədiyinizə əminsiniz?')) {
      console.log('Deleting country:', countryId);
      deleteCountry(countryId)
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if(editingCountry){
      updateCountry({id: editingCountry?.id,obj:formData})
    }else{
      addCountry(formData);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Get universities for the viewing country
  const getCountryUniversities = (countryName) => {
    return universities.filter(uni => uni.country === countryName);
  };

  // Get student requests for the viewing country
  const getCountryStudents = (countryName) => {
    return students.filter(student =>
      student.interestedCountries &&
      typeof student.interestedCountries === 'string' &&
      student.interestedCountries.includes(countryName)
    );
  };

   if (isLoading) {
            return (
                <div className='fixed inset-0 flex items-center bg-white opacity-[.5] justify-center'>
                    <Audio
                        height="80"
                        width="80"
                        radius="9"
                        color="green"
                        ariaLabel="loading"
                        wrapperStyle
                        wrapperClass
                    />
                </div>
            )
        }

  return (
    <div className="space-y-6">
      {/* Page header */}
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Ölkələr</h1>
          <p className="mt-1 text-sm text-gray-600">
            Təhsil üçün mövcud ölkələri idarə edin
          </p>
          <div className="mt-2 flex items-center space-x-4">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 border border-blue-200">
              Ümumi: {totalCountryCount}
            </span>
            {(searchTerm || statusFilter) && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 border border-green-200">
                Tapılan: {totalCountryCount}
              </span>
            )}
          </div>
        </div>
        <div className="mt-4 sm:mt-0 sm:flex sm:space-x-3">
        
          <ExportButton
                      setIsExport={setIsExport}
                      data={exportData}
                      filename="olkeler"
                      headers={exportHeaders}
                    />
          <button
            onClick={handleAdd}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
          >
            <PlusIcon className="-ml-1 mr-2 h-5 w-5" />
            Yeni Ölkə
          </button>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 max-w-4xl">
        <div className="md:col-span-2">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Ölkə adı və ya kod ilə axtarış..."
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md leading-5 bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Bütün statuslar</option>
            <option value="1">Yalnız aktiv</option>
            <option value="0">Yalnız deaktiv</option>
          </select>
        </div>
        <div>
          <button
            onClick={handleClearFilters}
            disabled={!searchTerm && !statusFilter}
            className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Filtri təmizlə
          </button>
        </div>
      </div>

      <TableHeader
                currentPage={currentPage}
                setItemsPerPage={setItemsPerPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                startIndex={startIndex}
                title={"Şəhərlər"}
                totalPages={totalPages}
                totalRecordCount={totalCountryCount}
              />

      {/* Countries table */}
      <div className="bg-white shadow-lg overflow-hidden sm:rounded-xl border border-blue-100">
        
        <div className="px-6 py-6">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b-2 border-blue-300">
                    <div className="flex items-center space-x-2">
                      <span>Ölkə Adı</span>
                      <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b-2 border-blue-300">
                    <div className="flex items-center space-x-2">
                      <span>Kod</span>
                      <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b-2 border-blue-300">
                    <div className="flex items-center space-x-2">
                      <span>Status</span>
                      <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b-2 border-blue-300">
                    <div className="flex items-center space-x-2">
                      <span>Yaradılma Tarixi</span>
                      <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider border-b-2 border-blue-300">
                    Əməliyyatlar
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {!isLoading && countriesData?.length > 0 && countriesData.map((country, index) => (
                  <tr key={country.id} className="hover:bg-gradient-to-r hover:from-blue-50 hover:to-blue-100 transition-all duration-200 group">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className={`flex-shrink-0 h-3 w-3 rounded-full mr-3 transition-colors ${country.is_active ? 'bg-blue-600 group-hover:bg-blue-700' : 'bg-gray-400 group-hover:bg-gray-500'
                          }`}></div>
                        <div className={`text-sm font-semibold transition-colors ${country.is_active ? 'text-gray-900 group-hover:text-blue-900' : 'text-gray-500 group-hover:text-gray-600'
                          }`}>
                          {country.name}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
                        {country.code}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${country.is_active
                        ? 'bg-emerald-100 text-emerald-800 border border-emerald-200'
                        : 'bg-red-100 text-red-800 border border-red-200'
                        }`}>
                        {country.is_active ? 'Aktiv' : 'Deaktiv'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-600 bg-blue-50 px-3 py-1 rounded-md border border-blue-100">
                        {new Date(country.created_at).toLocaleDateString('az-AZ')}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right">
                      <div className="flex justify-end space-x-2">
                        <button
                          onClick={() => handleView(country)}
                          className="inline-flex items-center p-2 bg-green-100 text-green-600 hover:bg-green-200 hover:text-green-800 rounded-lg transition-all duration-200 hover:scale-105"
                          title="Ətraflı bax"
                        >
                          <EyeIcon className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => handleEdit(country)}
                          className="inline-flex items-center p-2 bg-blue-100 text-blue-600 hover:bg-blue-200 hover:text-blue-800 rounded-lg transition-all duration-200 hover:scale-105"
                          title="Redaktə et"
                        >
                          <PencilIcon className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => handleDelete(country.id)}
                          className="inline-flex items-center p-2 bg-red-100 text-red-600 hover:bg-red-200 hover:text-red-800 rounded-lg transition-all duration-200 hover:scale-105"
                          title="Sil"
                        >
                          <TrashIcon className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          { false && (
            <div className="text-center py-16">
              <div className="mx-auto h-16 w-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center mb-4">
                <svg className="h-8 w-8 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Ölkə tapılmadı</h3>
              <p className="text-sm text-gray-500 max-w-sm mx-auto">
                Axtarış şərtlərinizi dəyişin və ya yeni ölkə əlavə edin.
              </p>
              <button
                onClick={handleAdd}
                className="mt-4 inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                <PlusIcon className="h-4 w-4 mr-2" />
                İlk Ölkəni Əlavə Et
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Pagination */}
      {/* {filteredCountries.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={filteredCountries.length}
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
        />
      )} */}

      {/* Add/Edit Modal */}
      {isModalOpen && (
        <CountryEditModal
          editingCountry={editingCountry}
          formData={formData}
          handleSubmit={handleSubmit}
          setFormData={setFormData}
          setIsModalOpen={setIsModalOpen}
        />
      )}

      {/* View Modal */}
      {isViewModalOpen && viewingCountry && (
        
        <CountryViewModal
                  setIsViewModalOpen={setIsViewModalOpen}
                  viewingCountry={viewingCountry}
                  handleEdit={handleEdit}
                />
      )}
    </div>
  );
} 